/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Search_Error_ToastInputs */

const en_error_nav_search_error_toast = /** @type {(inputs: Error_Nav_Search_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An error occurred while searching.`)
};

const fr_error_nav_search_error_toast = /** @type {(inputs: Error_Nav_Search_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une erreur s'est produite lors de la recherche.`)
};

const de_error_nav_search_error_toast = /** @type {(inputs: Error_Nav_Search_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bei der Suche ist ein Fehler aufgetreten.`)
};

const it_error_nav_search_error_toast = /** @type {(inputs: Error_Nav_Search_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si è verificato un errore durante la ricerca.`)
};

const ru_error_nav_search_error_toast = /** @type {(inputs: Error_Nav_Search_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`При поиске произошла ошибка.`)
};

const es_error_nav_search_error_toast = /** @type {(inputs: Error_Nav_Search_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se produjo un error durante la búsqueda.`)
};

const zh_cn2_error_nav_search_error_toast = /** @type {(inputs: Error_Nav_Search_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`搜索过程中发生错误。`)
};

const ja_error_nav_search_error_toast = /** @type {(inputs: Error_Nav_Search_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検索中にエラーが発生しました。`)
};

const hi_error_nav_search_error_toast = /** @type {(inputs: Error_Nav_Search_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`खोज करते समय एक त्रुटि उत्पन्न हुई।`)
};

const pt_pt2_error_nav_search_error_toast = /** @type {(inputs: Error_Nav_Search_Error_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ocorreu um erro durante a pesquisa.`)
};

/**
* | output |
* | --- |
* | "An error occurred while searching." |
*
* @param {Error_Nav_Search_Error_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_search_error_toast = /** @type {((inputs?: Error_Nav_Search_Error_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Search_Error_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_nav_search_error_toast(inputs)
	if (locale === "de") return de_error_nav_search_error_toast(inputs)
	if (locale === "it") return it_error_nav_search_error_toast(inputs)
	if (locale === "ru") return ru_error_nav_search_error_toast(inputs)
	if (locale === "es") return es_error_nav_search_error_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_error_nav_search_error_toast(inputs)
	if (locale === "ja") return ja_error_nav_search_error_toast(inputs)
	if (locale === "hi") return hi_error_nav_search_error_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_error_nav_search_error_toast(inputs)
	return en_error_nav_search_error_toast(inputs)
});